import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-mat-icon-button',
  templateUrl: './mat-icon-button.component.html',
  styleUrls: ['./mat-icon-button.component.scss'],
  imports: [MatIconModule, MatButtonModule, MatRippleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatIconButtonComponent {
  /** ID for the button element (optional)*/
  buttonId = input<string | undefined>(undefined);

  /** The button color style (optional, default: 'primary') */
  buttonStyle = input<'primary' | 'accent' | 'warn' | 'default' | 'grey' | 'selected' | 'negative' | 'dark-blue'>('primary');

  /** The name of the material icon to display (required) */
  iconName = input.required<string>();

  /** The HTML button type attribute (optional, default: 'button') */
  buttonType = input<'button' | 'submit' | 'reset'>('button');

  /** Whether the button is disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** ARIA label for accessibility (required) */
  ariaLabel = input.required<string>();

  /** Event emitted when the button is clicked */
  buttonClicked = output<void>();

  /** Handles the button click event and emits the buttonClicked event */
  clickButton = (): void => {
    this.buttonClicked.emit();
  };
}
